import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// Images
import icon1Import from '../../images/icon/contact/icon1.png';
import icon2Import from '../../images/icon/contact/icon2.png';
import icon3Import from '../../images/icon/contact/icon3.png';

import googlePlayIconImport from '../../images/GooglePlayIcon.webp';
import appStoreIconImport from '../../images/AppleAppStoreIcon.webp';

import LazyGoogleMaps from '../elements/LazyGoogleMaps';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import programmaticLinksFooter from '../../data/programmatic-links-footer.json';

// SSR-safe image resolution
const icon1 = typeof icon1Import === 'object' ? icon1Import.default : icon1Import;
const icon2 = typeof icon2Import === 'object' ? icon2Import.default : icon2Import;
const icon3 = typeof icon3Import === 'object' ? icon3Import.default : icon3Import;
const googlePlayIcon = typeof googlePlayIconImport === 'object' ? googlePlayIconImport.default : googlePlayIconImport;
const appStoreIcon = typeof appStoreIconImport === 'object' ? appStoreIconImport.default : appStoreIconImport;

class Footer extends Component {
  // componentDidMount() {
  //   // Add the Google Ads phone tracking script
  //   const script = document.createElement('script');
  //   script.innerHTML = `
  //     gtag('config', 'AW-11071705508/7pLhCL2ggrgYEKSjs58p', {
  //       'phone_conversion_number': '8031406663'
  //     });
  //   `;
  //   script.async = true;
  //   document.body.appendChild(script);
  // }

  render() {
    const { isMobileApp, setCitiesModal } = this.props;

    return (
      <>
        <footer className="footer">
          <div className="footer-info bg-primary">
            <div className="container">
              <div className="row align-items-center">
                {/* City Service Info */}
                <div className="col-lg-3 col-md-6 col-sm-6 mb-30">
                  <div className="feature-container left footer-info-bx">
                    <div className="icon-lg">
                      <span className="icon-cell">
                        <LazyLoadImage src={icon3} alt="Cities We Serve" effect="blur" />
                      </span>
                    </div>
                    <div className="icon-content">
                      <h6 style={{ margin: 0 }}>
                        <button
                          style={{
                            padding: 0,
                            textDecoration: 'underline',
                            background: 'none',
                            border: 'none',
                            color: '#fff',
                          }}
                          onClick={() => setCitiesModal(true)}
                        >
                          CITIES WE SERVE
                        </button>
                      </h6>
                    </div>
                  </div>
                </div>
                {/* Contact Info */}
                <div className="col-lg-3 col-md-6 col-sm-6 mb-30">
                  <div className="feature-container left footer-info-bx">
                    <div className="icon-lg">
                      <span className="icon-cell">
                        <LazyLoadImage src={icon1} alt="Call Us" effect="blur" />
                      </span>
                    </div>
                    <div className="icon-content">
                      <a href="tel:+911203615050">
                        <p>+91 120 361 5050</p>
                      </a>
                    </div>
                  </div>
                </div>
                {/* Email Info */}
                <div className="col-lg-3 col-md-6 col-sm-6 mb-30">
                  <div className="feature-container left footer-info-bx">
                    <div className="icon-lg">
                      <span className="icon-cell">
                        <LazyLoadImage src={icon2} alt="Email Us" effect="blur" />
                      </span>
                    </div>
                    <div
                      className="icon-content"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        if (typeof window !== 'undefined') {
                          window.location.href = 'mailto:info@ridenrepair.com';
                        }
                      }}
                    >
                      <p>info@ridenrepair.com</p>
                    </div>
                  </div>
                </div>
                {/* App Links */}
                {!isMobileApp && (
                  <div
                    className="col-lg-3 col-md-6 col-sm-6 mb-30 app-link-card"
                    style={{ backgroundColor: 'none' }}
                  >
                    <div className="app-links-row">
                      <a href="https://play.google.com/store/apps/details?id=com.ridenrepair.app">
                        <LazyLoadImage src={googlePlayIcon} alt="Google Play" effect="blur" />
                      </a>
                      <a href="https://apps.apple.com/us/app/ridenrepair/id6446174085">
                        <LazyLoadImage src={appStoreIcon} alt="App Store" effect="blur" />
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* Footer Top — 3 balanced columns (desktop/laptop), 2 on tablet, 1 on mobile */}
          <div className="footer-top bt0">
            <div className="container">
              <div className="row">
                {/* Column 1 — About + Follow Us */}
                <div className="col-lg-4 col-md-6 col-12">
                  <div className="widget footer_widget">
                    <h5 className="footer-title">About Ride N Repair</h5>
                    <p className="mb-20">
                      Looking for specialized two-wheeler or four-wheeler repair? Ride N Repair offers doorstep car and bike service with expert mechanics to meet and exceed your expectations.
                    </p>
                    <div className="ft-content">
                      <i className="fa fa-phone"></i>
                      <span>Talk To Our Support</span>
                      <a href="tel:+911203615050" id="google-tracked-phone">
                        <h4>+91 120 361 5050</h4>
                      </a>
                    </div>
                  </div>
                  <div className="widget widget_info">
                    <h5 className="footer-title">Follow Us</h5>
                    <ul className="list-inline ft-social-bx">
                      <li>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.facebook.com/weridenrepair"
                          className="btn button-sm"
                        >
                          <i className="fa fa-facebook social-icon"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.linkedin.com/company/ride-n-repair/"
                          className="btn button-sm"
                        >
                          <i className="fa fa-linkedin social-icon"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.instagram.com/weridenrepair"
                          className="btn button-sm"
                        >
                          <i className="fa fa-instagram social-icon"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href="https://www.youtube.com/channel/UC8RXTAzOW0SRX7whOyK-yJg"
                          className="btn button-sm"
                        >
                          <i className="fa fa-youtube social-icon"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Column 2 — Our Solutions + Popular Brands */}
                <div className="col-lg-4 col-md-6 col-12">
                  <div className="widget widget-link-2">
                    <h5 className="footer-title">Our Solutions</h5>
                    {/* 8 links across 2 ULs so the 2-column widget-link-2 grid
                        doesn't horizontally overlap when long labels wrap. */}
                    <ul>
                      <li><Link to="/about">About Us</Link></li>
                      <li><Link to="/careers">Careers</Link></li>
                      <li><Link to="/booking">Booking</Link></li>
                      <li><Link to="/faq">FAQ</Link></li>
                      <li><Link to="/contact">Contact Us</Link></li>
                      <li><Link to="/complaint">Raise a Complaint</Link></li>
                    </ul>
                    <ul>
                      <li><Link to="/terms-and-conditions">Terms &amp; Conditions</Link></li>
                      <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                      <li><Link to="/cancellation-policy">Cancellation Policy</Link></li>
                      <li><Link to="/refund-policy">Refund Policy</Link></li>
                    </ul>
                  </div>
                  <div className="widget widget-link-2">
                    <h5 className="footer-title">Popular Brands</h5>
                    <ul>
                      <li><Link to="/brands/hero">Hero</Link></li>
                      <li><Link to="/brands/honda">Honda</Link></li>
                      <li><Link to="/brands/bajaj">Bajaj</Link></li>
                      <li><Link to="/brands/royal-enfield">Royal Enfield</Link></li>
                    </ul>
                    <ul>
                      <li><Link to="/brands/maruti-suzuki">Maruti Suzuki</Link></li>
                      <li><Link to="/brands/hyundai">Hyundai</Link></li>
                      <li><Link to="/brands/tata">Tata</Link></li>
                      <li><Link to="/brands">All Brands &rarr;</Link></li>
                    </ul>
                  </div>
                </div>
                {/* Column 3 — Top Cities + Popular Services + Map */}
                <div className="col-lg-4 col-md-6 col-12">
                  {/* Top Cities — crawlable city links on every page (the modal
                      button above is JS-only and invisible to search). Mirrors the
                      Popular Brands widget pattern. */}
                  <div className="widget widget-link-2">
                    <h5 className="footer-title">Top Cities</h5>
                    <ul>
                      <li><Link to="/city/bengaluru">Bengaluru</Link></li>
                      <li><Link to="/city/delhi">Delhi</Link></li>
                      <li><Link to="/city/mumbai">Mumbai</Link></li>
                      <li><Link to="/city/pune">Pune</Link></li>
                    </ul>
                    <ul>
                      <li><Link to="/city/hyderabad">Hyderabad</Link></li>
                      <li><Link to="/city/chennai">Chennai</Link></li>
                      <li><Link to="/city/gurugram">Gurugram</Link></li>
                      <li><Link to="/city/noida">Noida</Link></li>
                    </ul>
                  </div>
                  {/* Popular Services — seeds crawl + passes authority to leaf pages.
                      Single-column list: labels are long, so a 2-col grid would overlap. */}
                  {programmaticLinksFooter && programmaticLinksFooter.length > 0 && (
                    <div className="widget footer-services-list">
                      <h5 className="footer-title">Popular Services</h5>
                      <ul>
                        {programmaticLinksFooter.slice(0, 8).map((l, i) => (
                          <li key={i}>
                            <Link to={l.url}>{l.label}</Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {/* Map Embed */}
                  {!isMobileApp && (
                    <div className="widget footer-map-widget">
                      <LazyGoogleMaps
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.905799118166!2d77.6266947766322!3d12.913775716140208!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15b62cc155a3%3A0xd0cca3178e6c0dc0!2sRide%20N%20Repair!5e0!3m2!1sen!2sus!4v1705098441199!5m2!1sen!2sus"
                        width="100%"
                        height="260"
                        title="Ride N Repair Location"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

export default Footer;
